import { apiService } from './api-service';

import type { Organization } from '@/types/models';

/**
 * Tenant-level config: the management-company branding shown on printed
 * statements (name, address, phone, fax, email, website).
 */
/**
 * An organization update payload.
 *
 * Nullable on purpose: the FK pointer columns (`selfVendorId`, the work-order GL
 * defaults) must be CLEARABLE, and only an explicit JSON `null` reaches the
 * server's UPDATE — omitting a key means "leave it alone" on that partial-update
 * endpoint, and `undefined` is dropped entirely by JSON.stringify.
 */
export type OrganizationPatch = {
	[K in keyof Organization]?: Organization[K] | null;
};

export const organizationService = {
	get: () => apiService.fetchApi('/organization') as Promise<Organization>,

	update: (body: OrganizationPatch) =>
		apiService.fetchApi('/organization', {
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
		}) as Promise<Organization>,
};
